class PageOverlay {
    constructor() {
        Object.defineProperty(this, "overlay", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.overlay = document.querySelector('#page-overlay');
    }
    open() {
        this.overlay?.classList.add('active');
    }
    close() {
        this.overlay?.classList.remove('active');
    }
}
export default new PageOverlay();
